import { render, staticRenderFns } from "./change_business.vue?vue&type=template&id=633d1712&scoped=true&"
import script from "./change_business.vue?vue&type=script&lang=js&"
export * from "./change_business.vue?vue&type=script&lang=js&"
import style0 from "./change_business.vue?vue&type=style&index=0&id=633d1712&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633d1712",
  null
  
)

export default component.exports